import { useParams, Link } from "react-router-dom";
import blogs from "../data/blogs";

export default function BlogDetail() {
    const { slug } = useParams();
    const blog = blogs.find((item) => item.slug === slug);

    if (!blog) {
        return (
            <p className="text-center py-28 text-xl text-white">
                ब्लॉग नहीं मिला
            </p>
        );
    }

    return (
        <main className="min-h-screen py-16">
            <div className="max-w-7xl mx-auto px-6">

                {/* 🔲 WHITE BOX */}
                <div className="bg-white rounded-3xl shadow-2xl p-6 md:p-12">

                    <Link to="/blogs" className="text-[#7a0c18] font-semibold">
                        ← सभी ब्लॉग्स
                    </Link>

                    <h1 className="mt-6 text-3xl md:text-5xl font-extrabold text-[#7a0c18]">
                        {blog.title}
                    </h1>

                    <p className="mt-2 text-gray-500">
                        {blog.date}
                    </p>

                    <div className="mt-12 grid grid-cols-1 md:grid-cols-2 gap-12 items-start">

                        <div className="order-1 md:order-2 md:sticky md:top-28">
                            <img
                                src={blog.image}
                                alt={blog.title}
                                className="w-full rounded-3xl shadow-xl"
                            />
                        </div>

                        <div className="order-2 md:order-1 text-lg text-gray-700 leading-relaxed whitespace-pre-line">
                            {blog.content}
                        </div>

                    </div>

                </div>
            </div>
        </main>
    );
}
